<template>
  <v-row class="justify-center align-center">
    <v-col cols="12" sm="6" lg="4">
      <v-card color="transparent" elevation="0">
        <h1 class="ra__contain-title">
          {{ $t('register') }}
        </h1>
        <v-form ref="registerForm" lazy-validation @submit.prevent="register">
          <v-alert v-if="form.errors.get('error')" outlined transition="scale-transition" type="error">
            {{ form.errors.get('error') }}
          </v-alert>
          <v-text-field ref="ref-registerForm-first-name" v-model="form.first_name" append-icon="mdi-account-outline"
            outlined :label="$t('first_name')" required />
          <v-text-field ref="ref-registerForm-last-name" v-model="form.last_name" append-icon="mdi-account-outline"
            outlined :label="$t('last_name')" :error-messages="form.errors.get('last_name')" required />
          <v-text-field ref="ref-registerForm-email" v-model="form.email" append-icon="mdi-email-outline" outlined
            :rules="rules.emailRules" :label="$t('email')" :error-messages="form.errors.get('email')" required />
          <v-text-field ref="ref-registerForm-password" v-model="form.password" :rules="rules.passwordRules"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" :label="$t('password')"
            outlined required :error-messages="form.errors.get('password')" @click:append="show1 = !show1" />
          <v-text-field ref="ref-registerForm-confirm-password" v-model="form.password_confirmation"
            :rules="rules.confirmPasswordRules.concat(passwordConfirmationRule)"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
            :label="$t('confirm_password')" :error-messages="form.errors.get('password_confirmation')" outlined required
            @click:append="show1 = !show1" />
          <div class="mb-4">
            <vue-recaptcha ref="recaptcha" @verify="isVerified" :sitekey="captchaSiteKey"></vue-recaptcha>
          </div>
          <v-btn ref="ref-registerForm-submit-btn" x-large type="submit" block :loading="form.busy" class="btn-primary">
            <span class="white--text">{{ $t('register') }}</span>
            <v-icon light>
              mid-key
            </v-icon>
          </v-btn>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Form from 'vform'
import VueRecaptcha from 'vue-recaptcha';
export default {

  layout: 'default',
  components: { VueRecaptcha },
  middleware: 'guest',
  metaInfo() {
    return { title: this.$t('register') }
  },

  data: () => ({
    form: new Form({
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
      recaptcha: null
    }),
    mustVerifyEmail: false,
    show1: false,
    show2: false,
    rules: {
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => (v && v.length >= 8) || 'Password must be more than 8 characters'
      ],
      confirmPasswordRules: [
        (v) => !!v || 'Confirm Password is required'
        // (v) => v === this.form.password || 'The password confirmation does not match.'
      ]
    },
    captchaSiteKey: process.env.MIX_NOCAPTCHA_SITEKEY
  }),
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.form.password === this.form.password_confirmation || 'The password confirmation does not match.'
    },

  },
  methods: {
    async register() {
      // this.recaptchaError = this.form.recaptcha == null ? true : false
      if (this.$refs.registerForm.validate()) {
        try {
          // Register the user.
          const { data } = await this.form.post('/register')

          // Must verify email fist.
          if (data.status) {
            this.mustVerifyEmail = true
          } else {
            // Log in the user.
            const { data } = await this.form.post('/login')
            console.log(data)
            // Save the token.
            this.$store.dispatch('auth/saveToken', { token: data.access_token })

            // Update the user.
            await this.$store.dispatch('auth/updateUser', { user: data })

            // Redirect home.
            this.$router.push({ name: 'home' })
            location.reload()
          }
        } catch (error) {
          this.$refs.recaptcha.reset();
        }
      }
    },
    isVerified(response) {
      console.log(response);
      this.form.recaptcha = response
    }

  },

}
</script>
